<template>
<div>
	<div class="d-flex justify-center" >
		<button
			v-if="$route.name !== 'payment'"
			:style="`color:${globalColors.primary}`"
			class="btn-quantity" 
			type="button" 
			@click="$emit('on-sub')"
		>
			-
		</button>
		<div class="number">{{ quantity }}</div>
		<button
			v-if="$route.name !== 'payment'"
			:style="`color:${globalColors.primary}`"
			class="btn-quantity"
			type="button" 
			@click="$emit('on-add')"
		>
			+
		</button>
	</div>
</div>
</template>

<script>

export default {
	name: 'button-quantity',
	props: {
		quantity: {
			default: 0,
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-quantity {
	background: none;
	border: 0.1rem solid #d6d6d6;
	font-size: size(medium);
	padding: 1rem;
}

.number {
	border: 0.1rem solid color(leadLight);
	font-family: font(open-bold);
	padding: 1rem;
}
</style>




// WEBPACK FOOTER //
// buttonQuantity.vue?9480944a